import React from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorWithLabel } from 'components/DataContainer';

export const EmptyOrErrorPlate = () => {
  const { t } = useTranslation();
  return <ErrorWithLabel label={t('catalog.plate.backend_error', 'Plate temporarily unavailable')} />;
};
